import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { NetezzaTableDataset } from 'app/model/dataset/netezza.dataset';
import { NetezzaLinkedService } from 'app/model/linkedservice/netezza.linkedservice';
import { partitionOptionConst, partitionOptions, partitionOptionForwardLinkMap } from '../consts/metadata-consts';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';
import { format } from 'app/shared/utils/string.util';

export const netezzaPartitionOptions = [
    partitionOptionConst.dataSlice,
    partitionOptionConst.dyamicRange,
    partitionOptionConst.none
];

export const netezzaTableMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(NetezzaTableDataset).name,
    displayName: stringResources.Netezza_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(NetezzaLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-netezza'
    },
    isFirstClass: true,
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
         stringResources.VersionLabel.toLocaleLowerCase()
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-netezza',
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.Time, ColumnType.Date),
    queryTooltipLink: partitionOptionForwardLinkMap[adfModelTypeMap.netezza.copySourceType],
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Database'],
    supportParallelRead: true,
    copySourceControls: [
        {
            type: 'radio-switch',
            label: stringResources.ModelName_Partition_Option,
            defaultValue: partitionOptionConst.dataSlice,
            description: '<a target="_blank" href="' + partitionOptionForwardLinkMap[adfModelTypeMap.netezza.copySourceType] + '">' + stringResources.LearnMore + '</a>',
            escapeDescription: false,
            options: partitionOptions.filter((p) => netezzaPartitionOptions.indexOf(p.value) >= 0).reverse(),
            bind: 'partitionOption',
            isParameterizable: true,
            cases: [
                {
                    caseValue: partitionOptionConst.dyamicRange,
                    children: [
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'columns-selection',
                                bind: 'partitionColumnName',
                                label: stringResources.ModelName_Partition_ColumnName,
                                multiple: false,
                                includeCopySourceProperties: true,
                                excludeSourceProperties: ['partitionOption', 'partitionSettings']
                            },
                            dynamicContentTextClass: 'input-spaced'
                        },
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'textbox',
                                bind: 'partitionUpperBound',
                                label: stringResources.ModelName_Partition_UpperBound
                            },
                            dynamicContentTextClass: 'input-spaced'
                        },
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'textbox',
                                bind: 'partitionLowerBound',
                                label: stringResources.ModelName_Partition_LowerBound
                            },
                            dynamicContentTextClass: 'input-spaced'
                        }
                    ]
                }
            ]
        }
    ]
};
